export default {
    name: "AnomalyDetectionChartWidget",
    type: "ChartWidget",
    description: "A chart showing detected anomalies over time.",
    roles: ["appUser"],
    widget: {
        title: "Anomaly Detections",
        size: "large",
        chartType: "line",
        dataProvider: {
            main: {
                rpc: "SonarRpc.getAnomalyDetections" // Assuming this RPC exists
            }
        },
        options: {
            responsive: true,
            scales: {
                y: {
                    beginAtZero: true
                }
            }
        }
    }
};